<div class="component-container">
  <div *ngIf="printData?.userName" class="heading">
    <div class="title">
      {{ printData?.userName }}
    </div>
  </div>
  <div
    *ngIf="printData?.userName"
    class="heading"
  >
    <div class="title">
      {{ printData?.userName }}
    </div>
  </div>
  <div
    class="heading flex xs:flex-col sm:flex-row md:flex-row justify-between items-center"
  >
    <div class="title">
      {{ !memberId ? "My " : "" }}Physical Activity
      <span class="additional-text">{{ additionalText }}</span>
    </div>
    <div class="controls flex flex-row justify-between items-center">
      <!--      <mat-radio-group (change)="toggleChart($event)"-->
      <!--                       [value]="dailyChart"-->
      <!--                       class="flex flex-row items-center">-->
      <!--        <mat-radio-button [value]="true">Daily</mat-radio-button>-->
      <!--        <div class="vertical-divider"></div>-->
      <!--        <mat-radio-button [value]="false">Weekly</mat-radio-button>-->
      <!--      </mat-radio-group>-->
      <mat-checkbox
        *ngIf="!isAdult"
        (ngModelChange)="toggleTarget()"
        [(ngModel)]="showTarget"
        >Show Daily Goals
      </mat-checkbox>
    </div>
  </div>
  <div
    class="chart-container flex-row flex w-full xs:h-[50rem] sm:h-[50rem] md:h-[50rem]"
  >
    <ng-container *ngIf="dailyChart">
      <div
        *ngIf="groupedBarChartData?.loading"
        class="chart-loader w-full h-full flex justify-center items-center"
      >
        <mat-spinner
          [diameter]="60"
          strokeWidth="5"
        />
      </div>
      <grouped-bar-chart
        chartName="physical-activity"
        *ngIf="groupedBarChartData?.data"
        [chartData]="groupedBarChartData.data"
        [showTargetLine]="showTarget"
        [xAxisLabel]="'Weeks'"
        [yAxisLabel]="'Points'"
        class="w-full"
      ></grouped-bar-chart>
      <div
        *ngIf="!groupedBarChartData?.loading && !groupedBarChartData?.data"
        class="no-chart-data w-full h-full flex justify-center items-center"
      >
        No data to show on chart.
      </div>
    </ng-container>
    <!--    <ng-container *ngIf="!dailyChart">-->
    <!--      <div *ngIf="barChartData?.loading"-->
    <!--           class="chart-loader w-full h-full flex justify-center items-center">-->
    <!--        <mat-spinner-->
    <!--          [diameter]="60"-->
    <!--          strokeWidth="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <bar-chart *ngIf="barChartData?.data"-->
    <!--                 chartName="physical-activity"-->
    <!--                 [chartData]="barChartData.data"-->
    <!--                 [showTargetLine]="showTarget"-->
    <!--                 [xAxisLabel]="'Weeks'"-->
    <!--                 [yAxisLabel]="'Points'"-->
    <!--                 class="w-full h-full"></bar-chart>-->
    <!--      <div *ngIf="!barChartData?.loading && !barChartData?.data"-->
    <!--           class="no-chart-data w-full h-full flex justify-center items-center">-->
    <!--        No data to show on chart.-->
    <!--      </div>-->
    <!--    </ng-container>-->
  </div>

  <div class="table-container w-full">
    <div class="w-full xs:overflow-x-auto sm:overflow-x-auto">
      <div
        (scrolled)="onScroll()"
        [fromRoot]="true"
        [immediateCheck]="true"
        [infiniteScrollDisabled]="
          !(groupedBarChartData?.data || barChartData?.data)
        "
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="10"
        [scrollWindow]="false"
        class="table-wrapper table-container xs:w-[80rem] sm:w-[80rem] md:w-full {{
          printData
            ? ''
            : 'xs:max-h-[85vh] sm:max-h-[85vh] md:max-h-[calc(90vh-6rem)] xl:max-h-[calc(95vh-6rem)] overflow-auto'
        }}"
        infiniteScroll
      >
        <table
          *ngIf="chartTableData?.data?.list?.length"
          [dataSource]="chartTableData?.data?.list"
          mat-table
        >
          <ng-container matColumnDef="week">
            <th
              *matHeaderCellDef
              mat-header-cell
              class="sortable-header cursor-pointer"
              (click)="onSort('weekNumber')"
            >
              Week
              <span class="sort-indicator">
                <ng-container *ngIf="sortColumn === 'weekNumber'">
                  <span *ngIf="sortOrder === 'asc'">↑</span>
                  <span *ngIf="sortOrder === 'desc'">↓</span>
                </ng-container>
              </span>
            </th>
            <td
              *matCellDef="let element"
              class="w-[10%]"
              mat-cell
            >
              {{ element.weekNumber || "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dateRange">
            <th
              *matHeaderCellDef
              mat-header-cell
              class="sortable-header cursor-pointer"
              (click)="onSort('weekNumber')"
            >
              Date Range
              <span class="sort-indicator">
                <ng-container *ngIf="sortColumn === 'weekNumber'">
                  <span *ngIf="sortOrder === 'asc'">↑</span>
                  <span *ngIf="sortOrder === 'desc'">↓</span>
                </ng-container>
              </span>
            </th>
            <td
              *matCellDef="let element"
              class="w-[20%]"
              mat-cell
            >
              {{ element.dateRange.start | date: "MMM dd, yyyy" }} -
              {{ element.dateRange.end | date: "MMM dd, yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="sessions">
            <th
              mat-header-cell
              *matHeaderCellDef
            >
              Session
            </th>
            <td
              style="
                min-width: 12rem;
                max-width: 18rem;
                overflow: visible;
                white-space: nowrap;
              "
              class="sessions-cell w-[16%]"
              mat-cell
              *matCellDef="let element"
            >
              <ng-container *ngIf="element.sessions?.length; else noSessions">
                <div
                  *ngFor="let session of element.sessions"
                  class="td-cell session flex flex-col gap-[1rem]"
                >
                  <div
                    *ngIf="session['sessionNumber']"
                    class="session flex flex-row justify-start items-center gap-x-[1rem]"
                  >
                    <span class="pill-container">
                      S{{ session.sessionNumber | number: "2.0-0" }}
                    </span>
<!--                    <span class="session-date">-->
<!--                      {{ session.date | date: "MMM dd" }}-->
<!--                    </span>-->
                  </div>
                </div>
              </ng-container>
              <ng-template #noSessions>
                <span>-</span>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="weekTotal">
            <th
              *matHeaderCellDef
              mat-header-cell
              >{{ isAdult ? 'Days with Physical Activity' : 'Days meeting physical activity goal'}}
            </th>
            <td
              *matCellDef="let element"
              class="w-[18%]"
              mat-cell
            >
              <ng-container *ngIf="isAdult; else nonAdult">
                <span>{{ formatDays(element.pa_days) || '-' }}</span>
              </ng-container>

              <ng-template #nonAdult>
                  <span *ngIf="hasGoalData(element); else dash">
                  {{
                    element.goal_completed_days + ' ' + pluralizeDay(element.goal_completed_days) +
                    ' @ ' + (element.goal | number: '1.0-0' : 'en-US') + '+'
                    }}
                  </span>
                <ng-template #dash>-</ng-template>
              </ng-template>
            </td>
          </ng-container>

          <ng-container  matColumnDef="weekTarget">
            <th
              *matHeaderCellDef
              mat-header-cell
            >
              Physical Activity Goal
            </th>
            <td
              *matCellDef="let element"
              class="w-[18%]"
              mat-cell
            >
              <div
                class="role-color-circle-container flex flex-row items-center"
              >
                <span *ngIf="element.goal && element.goal_days">
                  {{
                    element["goal_days"] +
                      " day" +
                      (element["goal_days"] !== 1 ? "s" : "") +
                      " @ " +
                      (element["goal"] | number: "1.0" : "en-US") +
                      "+"
                  }}
                </span>
                <span *ngIf="!(element.goal && element.goal_days)">-</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="dayTotal">
            <th
              *matHeaderCellDef
              mat-header-cell
            >
              Days of journaling physical activity
            </th>
            <td
              *matCellDef="let element"
              class="w-[18%]"
              mat-cell
            >
              <div
                class="role-color-circle-container flex flex-row items-center"
              >
                <span>{{ element.days_entered || "-" }}</span>
              </div>
            </td>
          </ng-container>

          <tr
            *matHeaderRowDef="columns; sticky: true"
            mat-header-row
          ></tr>
          <tr
            *matRowDef="let row; columns: columns"
            mat-row
          ></tr>
          <tr
            *matNoDataRow
            class="mat-row"
          >
            <td
              [colSpan]="columns.length"
              class="mat-cell"
            >
              No data found.
            </td>
          </tr>
        </table>

        <div
          *ngIf="
            ((dailyChart && groupedBarChartData?.data) ||
              (!dailyChart && barChartData?.data)) &&
            chartTableData?.loading
          "
          class="chart-table-loader w-full h-[10rem] flex justify-center items-center"
        >
          <mat-spinner
            [diameter]="60"
            strokeWidth="5"
          />
        </div>
      </div>
    </div>
  </div>
</div>
